import dateAndTime from "date-and-time";
import {
  Category,
  CategoryUnlockCode,
  Subcategory,
} from "../../domain/model/Category";
import { DifficultyInfo } from "../../domain/model/Question";
import { TFunction } from "i18next";
import { COLOR_GREEN } from "../../data/colors/Colors";
import SharedPreferences from "./SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";
import { Player } from "../../domain/model/User";

export function formateDate(
  date: Date,
  formatText: string = "DD MMM YYYY hh:mm A"
) {
  return dateAndTime.format(new Date(date), formatText);
}

export function capitalizeFirstLetters(str: string) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

export function calculateGamesLeftForSubcategory(
  category: Category,
  subcategory: Subcategory
): number {
  const subcategoryNumberOfQuestionsModel =
    category.numberOfQuestionsForEachSubcategory?.filter(
      (item) => item.subcategory == subcategory.title
    )[0];
  const minimumNumberOfQuestionsBetweenDifficulties = Math.min(
    subcategoryNumberOfQuestionsModel?.easyDifficultyTotalQuestions ?? 0,
    subcategoryNumberOfQuestionsModel?.mediumDifficultyTotalQuestions ?? 0,
    subcategoryNumberOfQuestionsModel?.hardDifficultyTotalQuestions ?? 0
  );

  const gamesLeft = Math.round(minimumNumberOfQuestionsBetweenDifficulties / 2);

  return gamesLeft;
}

export function getDifficultyInfo(
  difficulty: string,
  t: TFunction<"translation", undefined>
): DifficultyInfo {
  if (difficulty == "Easy") {
    return {
      color: COLOR_GREEN,
      point: 250,
      text: t("easy"),
    };
  } else if (difficulty == "Medium") {
    return {
      color: "#FFBF00",
      point: 500,
      text: t("medium"),
    };
  } else {
    return {
      color: "red",
      point: 750,
      text: t("hard"),
    };
  }
}

export function formattedTime(timeInSecond: number) {
  const sec = timeInSecond % 60;
  const min = Math.floor(timeInSecond / 60);
  const minute = min.toString().length <= 1 ? `0${min}` : `${min}`;
  const second = sec.toString().length <= 1 ? `0${sec}` : `${sec}`;
  return `${minute} : ${second}`;
}

export function getUserInfoAgain() {
  SharedPreferences.setNumber(
    STORAGE_KEYS.SHOULD_FETCH_PLAYER_AGAIN,
    new Date().getMilliseconds()
  );
}

export function showGlobalLoadingView(show: boolean) {
  SharedPreferences.setBoolean(STORAGE_KEYS.SHOW_LOADING, show);
}

export function openLink(link: string, target: "_self" | "_blank" = "_self") {
  window.open(link, target, "noopener,noreferrer");
}

export function isCategoryLocked(
  player: Player,
  categoryId: string,
  categoryLocked: boolean
): boolean {
  if (categoryLocked) {
    if (player.unlockedCategories) {
      return (
        player.unlockedCategories.filter((s) => s == categoryId).length == 0
      );
    }
    return true;
  }
  return false;
}

export function getReferralLinkFromUnlockCode(
  unlockCode: CategoryUnlockCode
): string {
  const url = `https://ellytbeeh.qa/unlockCode?id=${unlockCode._id}`;
  return url;
}

export function shouldPlaySounds(): boolean {
  return SharedPreferences.getBoolean(STORAGE_KEYS.PLAY_SOUNDS) == true;
}
